module.exports = __webpack_public_path__ + "img/events-2.27e19d5b.png";